import {RCS, SMS, USSD, WHATSAPP} from '../../../../../shared/utils/config';
import {OutboundTranslator, TranslationResponse} from './translatorUtils';
import translateToOneApi from './one-api-translator';
import translateToYaga from './yaga-translator';

export const outboundTranslator = (translate: OutboundTranslator): TranslationResponse => {
    switch (translate.channelId) {
        case USSD:
            console.error('This is not supported');
            break;
        case WHATSAPP:
        case SMS:
            return translateToOneApi(translate);
        case RCS:
            return translateToYaga(translate);
    }
};
